import React, { useEffect, useState } from "react";
import { Lock } from "lucide-react";

function fmt(s) {
  const m = Math.floor(s / 60);
  const sec = String(Math.max(0, s % 60)).padStart(2, "0");
  return `${m}:${sec}`;
}

// Self-ticking "holding · 0:59" pill. Owns its own 1s interval so the
// countdown updates WITHOUT re-rendering the whole outreach table (only
// the one held row mounts this). Auto-release of the hold itself lives in
// the parent (a setTimeout keyed on expiresAt), so this is display-only.
export default function HoldCountdownBadge({ expiresAt, id }) {
  const [left, setLeft] = useState(() =>
    Math.max(0, Math.ceil((expiresAt - Date.now()) / 1000)),
  );
  useEffect(() => {
    setLeft(Math.max(0, Math.ceil((expiresAt - Date.now()) / 1000)));
    const iv = setInterval(() => {
      setLeft(Math.max(0, Math.ceil((expiresAt - Date.now()) / 1000)));
    }, 1000);
    return () => clearInterval(iv);
  }, [expiresAt]);

  return (
    <span
      className="inline-flex items-center gap-1 h-5 px-1.5 rounded-full bg-sky-100 text-sky-800 text-[10px] font-semibold tabular-nums shrink-0"
      title="Held in place for a moment while you work this realtor's socials"
      data-testid={`outreach-hold-badge-${id}`}
    >
      <Lock className="h-2.5 w-2.5" />
      holding · {fmt(left)}
    </span>
  );
}
